import script from "./SupplierFormModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./SupplierFormModal.vue?vue&type=script&lang=ts&setup=true"

import "./SupplierFormModal.vue?vue&type=style&index=0&id=5d5e47e2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d5e47e2"]])

export default __exports__